import useSocketReconnect from '../../../utils/useSocketReconnect';
import DeleteButton from './DeleteButton';
import NotifyButton from './NotifyButton';
import SwapButton from './SwapButton';
import FitxarButton from './FitxarButton';
import './FloatingButtons.css'
import { useEffect, useState, memo } from 'react';
import { isBrowser } from 'react-device-detect';
import DummyButton from './DummyButton';

const FloatingButtons = memo((props) => {
    const { socket, isModel } = props;
    const { selectedEvent, selectedBundle, selectedVersio } = props;

    const [user, setUser] = useState(-1);
    const [assistencia, setAssistencia] = useState(null);
    useSocketReconnect(socket, () => {
        const selectedUser = props.posicions?.caixes?.[props.caixaSelected];
        if (selectedUser !== undefined) socket.emit('.request_assistencia', selectedEvent, selectedUser);
    });


    useEffect(() => {
        const { caixaSelected, posicions } = props;
        if (caixaSelected in posicions.caixes) {
            const _user = posicions.caixes[caixaSelected];
            socket.emit('.request_assistencia', selectedEvent, _user);
            const onAssistencia = res => setAssistencia(res.assistencia);
            socket.on(`.assistencia`, onAssistencia);
            setUser(_user);

            return () => socket.off(`.assistencia`, onAssistencia);
        } else if (caixaSelected === -1) {
            setAssistencia(null);
        }
    }, [props.caixaSelected]);

    const exports = {
        'user': user,
        'assistencia': assistencia,
        'setAssistencia': setAssistencia,

        'event': selectedEvent,
        'castell': selectedBundle,
        'versio': selectedVersio,
        ...props
    };

    return (
        <>
            <div className='floating buttons-container'>
                { !isModel && <FitxarButton {...exports} /> }
                <SwapButton {...exports} />
            </div>

            <div className='floating dangerous buttons-container'>
                <DeleteButton {...exports} />
                {/* { !isModel && <NotifyButton {...exports} /> } */}
                <DummyButton />
            </div>
        </>
    );
}, (prevProps, nextProps) =>
    false &&
    prevProps.isModel === nextProps.isModel &&
    prevProps.selectedEvent === nextProps.selectedEvent &&
    prevProps.selectedBundle === nextProps.selectedBundle &&
    prevProps.selectedVersio === nextProps.selectedVersio &&
    prevProps.caixaSelected === nextProps.caixaSelected &&
    JSON.stringify(prevProps.posicions) === JSON.stringify(nextProps.posicions)
);

export default FloatingButtons;
